import { PreparedStampWebps } from './stampPreparationCache';
/** Versioned supplied artwork stays separate from personal normalized board assets. */
export const COLLECTION_ROOT='/collections/noto-18-e20cbc2-webp90-1080-v1';
export interface CollectionArtwork {id:string;label:string;thumbnail:string;artwork:string;emoji?:string}
export interface EmojiVariant extends CollectionArtwork {tones:number[]}
export interface EmojiFamily {id:string;label:string;keywords:string[];category:string;default:EmojiVariant;variants:EmojiVariant[]}
export interface StickerEntry extends CollectionArtwork {category:string;keywords:string[]}
export interface StampCollection {schemaVersion:1;version:string;categories:{emoji:Array<{id:string;label:string}>;stickers:Array<{id:string;label:string}>};emoji:EmojiFamily[];stickers:StickerEntry[]}
let collection:Promise<StampCollection>|null=null;
const preparedWebps = new PreparedStampWebps();
/** Shared metadata loading is retryable; an individual picker cannot cancel other readers. */
export function loadStampCollection():Promise<StampCollection>{
 if(collection)return collection;
 const pending=fetch(`${COLLECTION_ROOT}/index.json`,{credentials:'same-origin',cache:'default'}).then(async response=>{
  if(!response.ok)throw new Error('The stamp library could not load. Try again.');
  const result=await response.json() as StampCollection;
  if(result.schemaVersion!==1||!Array.isArray(result.emoji)||!Array.isArray(result.stickers)||!result.categories)throw new Error('The stamp library is unavailable. Try again.');
  return result;
 });
 collection=pending;
 void pending.catch(()=>{if(collection===pending)collection=null;});return pending;
}
export async function warmStampCollection():Promise<void>{try{await loadStampCollection();}catch{/* Library failure never blocks the street. */}}
/** One ready immutable WebP is shared by byte reuse and ordinary browser caching. */
export async function collectionArtworkBlob(artwork:CollectionArtwork,signal?:AbortSignal):Promise<Blob>{
 signal?.throwIfAborted();
 if(!artwork.artwork.startsWith(`${COLLECTION_ROOT}/`)||!/^\/(?:emoji|stickers)\/[a-z0-9_-]+\.webp$/.test(artwork.artwork.slice(COLLECTION_ROOT.length)))throw new Error('This stamp source is unavailable.');
 const cached=preparedWebps.get(artwork.artwork);if(cached)return cached;
 const response=await fetch(artwork.artwork,{credentials:'same-origin',signal,cache:'default'});
 if(!response.ok)throw new Error('This stamp could not load. Your selection is safe; try again.');
 const source=await response.blob();signal?.throwIfAborted();
 if(source.type!=='image/webp'||!source.size)throw new Error('This stamp artwork could not be read. Your selection is safe.');
 preparedWebps.set(artwork.artwork,source);return source;
}
